import { useState } from 'react';

// Número de WhatsApp no formato internacional
const WHATSAPP_NUMBER = '5511913278081';
const WHATSAPP_DIRECT = `https://wa.me/${WHATSAPP_NUMBER}?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.`;

// Opções de área do caso
const AREAS_CASO = [
  'Direito Trabalhista',
  'Direito Civil',
  'Direito Previdenciário',
  'Direito de Família',
  'Direito Criminal',
  'Direito Empresarial',
  'Outro',
];

export default function Contato() {
  const [charCount, setCharCount] = useState(0);

  // Ao enviar, monta a mensagem e redireciona para o WhatsApp
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    // Impede o comportamento padrão do formulário (recarregamento de página)
    e.preventDefault();

    const form = e.currentTarget;

    // Captura os valores dos campos
    const nome = (form.querySelector('[name="nome"]') as HTMLInputElement).value.trim();
    const email = (form.querySelector('[name="email"]') as HTMLInputElement).value.trim();
    const area = (form.querySelector('[name="area_caso"]') as HTMLSelectElement).value;
    const mensagem = (form.querySelector('[name="mensagem"]') as HTMLTextAreaElement).value.trim();

    // Monta a mensagem com a estrutura exata solicitada
    const textoMontado =
      `Nome Completo: ${nome} | E-mail: ${email} | Área do Caso: ${area} | Motivo do Contato: ${mensagem}`;

    // Converte para formato URL
    const textoCodificado = encodeURIComponent(textoMontado);

    // Redireciona para o WhatsApp em nova aba com a mensagem pronta
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${textoCodificado}`, '_blank');
  };

  return (
    <section id="contato" className="py-[60px] bg-[#F8F5EE]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Fale conosco
            </span>
            <span className="h-px w-12 bg-[#B39B62]"></span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-[#0A1829] font-light mb-4">
            Entre em <span className="italic text-[#B39B62]">Contato</span>
          </h2>
          <p className="font-sans text-[#0A1829]/60 text-base max-w-xl mx-auto leading-relaxed">
            Descreva sua situação brevemente. Responderemos com agilidade e sigilo total.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Formulário */}
          <div className="bg-white rounded-lg border border-[#E9D59C]/50 p-8">
            <form
              id="form-contato"
              onSubmit={handleSubmit}
              className="space-y-5"
            >
              {/* Campo: Nome Completo */}
              <div>
                <label className="block font-sans text-xs font-semibold text-[#0A1829]/70 tracking-wider uppercase mb-2">
                  Nome Completo <span className="text-[#B39B62]">*</span>
                </label>
                <input
                  type="text"
                  name="nome"
                  required
                  placeholder="Seu nome completo"
                  className="w-full border border-[#E9D59C]/60 rounded-md px-4 py-3 font-sans text-sm text-[#0A1829] bg-[#F8F5EE] focus:outline-none focus:border-[#B39B62] transition-colors placeholder:text-[#0A1829]/30"
                />
              </div>

              {/* Campo: E-mail */}
              <div>
                <label className="block font-sans text-xs font-semibold text-[#0A1829]/70 tracking-wider uppercase mb-2">
                  E-mail <span className="text-[#B39B62]">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="seuemail@exemplo.com"
                  className="w-full border border-[#E9D59C]/60 rounded-md px-4 py-3 font-sans text-sm text-[#0A1829] bg-[#F8F5EE] focus:outline-none focus:border-[#B39B62] transition-colors placeholder:text-[#0A1829]/30"
                />
              </div>

              {/* Campo: Área do Caso (select obrigatório) */}
              <div>
                <label className="block font-sans text-xs font-semibold text-[#0A1829]/70 tracking-wider uppercase mb-2">
                  Área do Caso <span className="text-[#B39B62]">*</span>
                </label>
                <select
                  name="area_caso"
                  required
                  defaultValue=""
                  className="w-full border border-[#E9D59C]/60 rounded-md px-4 py-3 font-sans text-sm text-[#0A1829] bg-[#F8F5EE] focus:outline-none focus:border-[#B39B62] transition-colors cursor-pointer"
                >
                  <option value="" disabled>Selecione a área do seu caso</option>
                  {AREAS_CASO.map((area) => (
                    <option key={area} value={area}>{area}</option>
                  ))}
                </select>
              </div>

              {/* Campo: Mensagem */}
              <div>
                <label className="block font-sans text-xs font-semibold text-[#0A1829]/70 tracking-wider uppercase mb-2">
                  Mensagem <span className="text-[#B39B62]">*</span>
                </label>
                <textarea
                  name="mensagem"
                  required
                  rows={4}
                  maxLength={500}
                  placeholder="Descreva brevemente o ocorrido ou sua necessidade..."
                  onChange={(e) => setCharCount(e.target.value.length)}
                  className="w-full border border-[#E9D59C]/60 rounded-md px-4 py-3 font-sans text-sm text-[#0A1829] bg-[#F8F5EE] focus:outline-none focus:border-[#B39B62] transition-colors placeholder:text-[#0A1829]/30 resize-none"
                />
                <div className="flex justify-end mt-1">
                  <span className={`font-sans text-xs ${charCount > 450 ? 'text-red-400' : 'text-[#0A1829]/40'}`}>
                    {charCount}/500
                  </span>
                </div>
              </div>

              {/* Botão de envio — abre WhatsApp com mensagem pré-preenchida */}
              <button
                type="submit"
                className="w-full bg-[#0A1829] hover:bg-[#B39B62] text-white hover:text-[#0A1829] font-sans font-semibold text-sm py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-whatsapp-line"></i>
                Enviar pelo WhatsApp
              </button>
            </form>
          </div>

          {/* Info */}
          <div className="space-y-8">
            {/* WhatsApp Urgência */}
            <div className="bg-[#0A1829] rounded-lg p-8">
              <div className="mb-4">
                <h3 className="font-serif text-3xl text-white font-medium">Precisa de assessoria jurídica?</h3>
              </div>
              <p className="font-sans text-white/60 text-sm leading-relaxed mb-5">
                Em casos urgentes como flagrante, prisão ou questões que exigem ação imediata, o tempo é crucial. Fale conosco agora pelo WhatsApp.
              </p>
              <a
                href={WHATSAPP_DIRECT}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-base"></i>
                (11) 91327-8081
              </a>
            </div>

            {/* Address / Info Card */}
            <div className="bg-white rounded-lg border border-[#E9D59C]/50 p-8 space-y-6">
              {/* Endereço */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#B39B62]/15 border border-[#B39B62]/30 shrink-0">
                  <i className="ri-map-pin-2-fill text-[#B39B62] text-xl"></i>
                </div>
                <div>
                  <div className="font-sans text-xs font-semibold text-[#0A1829]/50 uppercase tracking-wider mb-1">Endereço</div>
                  <div className="font-sans text-sm text-[#0A1829] leading-relaxed">
                    Av. Marquês de São Vicente, 121<br />Barra Funda, São Paulo/SP
                  </div>
                </div>
              </div>

              <div className="h-px bg-[#E9D59C]/40"></div>

              {/* Telefone */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#B39B62]/15 border border-[#B39B62]/30 shrink-0">
                  <i className="ri-whatsapp-line text-[#B39B62] text-xl"></i>
                </div>
                <div>
                  <div className="font-sans text-xs font-semibold text-[#0A1829]/50 uppercase tracking-wider mb-1">WhatsApp</div>
                  <a
                    href={WHATSAPP_DIRECT}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-sans text-sm text-[#B39B62] hover:text-[#0A1829] transition-colors cursor-pointer"
                  >
                    (11) 91327-8081
                  </a>
                </div>
              </div>

              <div className="h-px bg-[#E9D59C]/40"></div>

              {/* Instagram */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#B39B62]/15 border border-[#B39B62]/30 shrink-0">
                  <i className="ri-instagram-line text-[#B39B62] text-xl"></i>
                </div>
                <div>
                  <div className="font-sans text-xs font-semibold text-[#0A1829]/50 uppercase tracking-wider mb-1">Instagram</div>
                  <a
                    href="https://instagram.com/advogados.moreiratofoli"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="font-sans text-sm text-[#B39B62] hover:text-[#0A1829] transition-colors cursor-pointer"
                  >
                    @advogados.moreiratofoli
                  </a>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-lg overflow-hidden border border-[#E9D59C]/50" style={{ height: '200px' }}>
              <iframe
                title="Localização Moreira e Tofoli Advogados"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.05!2d-46.6659!3d-23.529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sAv.+Marqu%C3%AAs+de+S%C3%A3o+Vicente%2C+121%2C+Barra+Funda%2C+S%C3%A3o+Paulo!5e0!3m2!1spt!2sbr!4v1700000000001!5m2!1spt!2sbr"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
